import { render, staticRenderFns } from "./o-hero-text-v2.vue?vue&type=template&id=13f85b12&scoped=true"
import script from "./o-hero-text-v2.vue?vue&type=script&lang=js"
export * from "./o-hero-text-v2.vue?vue&type=script&lang=js"
import style0 from "./o-hero-text-v2.vue?vue&type=style&index=0&id=13f85b12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f85b12",
  null
  
)

export default component.exports